import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { DashboardDisplay } from './DashboardDisplay'
import { FC } from 'react'
import { Menu, useMarketingMenuData } from './seo-menu'
import { MenuProvider } from './seo-menu/context'
import { NAV_V2_LOGGED_OUT_LINKS_BP } from '@dtx-company/true-common/src/constants/layout'
import { NavLinksProps } from './NavLinks.types'
import { RootCodeState } from '@dtx-company/inter-app/src/redux/types'
import { SignInOptions } from './SignInOptions'
import { mediaMaxWidth } from '@dtx-company/shared-components/src/theme/media-queries'
import { useCodeSelector } from '@dtx-company/inter-app/src/hooks/useCodeSelector'
import { useScreenSizeBreakpoints } from '@app/common/src/hooks/useScreenSizeBreakpoints'
import styled from 'styled-components'

const LinksWrapper = styled(Box)`
  justify-content: center;
  width: 100%;
  flex-grow: 1;
  ${mediaMaxWidth.custom(NAV_V2_LOGGED_OUT_LINKS_BP - 1)} {
    display: none;
  }
`

export const MarketingNavLinks: FC<NavLinksProps> = ({ isLoggedIn, isFPHomepage = false }) => {
  const marketingMenuData = useMarketingMenuData()
  const { hideNavbarSignInOptions } = useCodeSelector((state: RootCodeState) => state.settings)

  const { isMobile } = useScreenSizeBreakpoints()

  return (
    <Box
      justifyContent="center"
      width="100%"
      data-testid="marketing-nav-desktop"
      // logo width
      pr={hideNavbarSignInOptions ? '142px' : undefined}
    >
      <LinksWrapper>
        <MenuProvider>
          <Menu menuItems={marketingMenuData} />
        </MenuProvider>
      </LinksWrapper>

      {/* Auth/Dashboard buttons */}
      {isLoggedIn && !isMobile && <DashboardDisplay />}
      {!isLoggedIn && !hideNavbarSignInOptions && <SignInOptions isFPHomepage={isFPHomepage} />}
    </Box>
  )
}
